import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Link,
  Divider,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Email,
  Phone,
  WhatsApp,
} from '@mui/icons-material';
import Logo from './Logo';

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#1a1a1a',
        color: 'white',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Logo />
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  ml: 2,
                }}
              >
                {/* SlotSnap */}
              </Typography>
            </Box>
            
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              Simplifying appointment booking for clinics, beauty parlors, and salons. 
              Your time is valuable - book smart, book fast.
            </Typography>

            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: '#1877f2' },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: '#1da1f2' },
                }}
              >
                <Twitter />
              </IconButton>
              <IconButton
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: '#e4405f' },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: '#0077b5' },
                }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: 'white',
                mb: 2,
              }}
            >
              Quick Links
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="#about"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: 'white' },
                }}
              >
                About Us
              </Link>
              <Link
                href="#services"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: 'white' },
                }}
              >
                Services
              </Link>
              <Link
                href="#contact"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: 'white' },
                }}
              >
                Contact
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: 'white',
                mb: 2,
              }}
            >
              Services
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" color="rgba(255,255,255,0.7)">
                Slot Booking
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.7)">
                Walk-in Management
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.7)">
                Mobile App
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.7)">
                QR Code Booking
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.7)">
                WhatsApp Integration
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: 'white',
                mb: 2,
              }}
            >
              Contact Info
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 20, color: 'primary.main' }} />
                <Typography variant="body2" color="rgba(255,255,255,0.7)">
                  slotsnap.in@gmail.com
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 20, color: 'success.main' }} />
                <Typography variant="body2" color="rgba(255,255,255,0.7)">
                  +91 7569807018
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WhatsApp sx={{ fontSize: 20, color: '#25D366' }} />
                <Typography variant="body2" color="rgba(255,255,255,0.7)">
                  +91 7569807018
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, backgroundColor: 'rgba(255,255,255,0.1)' }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="rgba(255,255,255,0.7)">
            © 2024 SlotSnap. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link
              href="#"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: 'white' },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: 'white' },
              }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

